import { API } from '.'
import type { PlanningYearsResponse } from './dto/planning.dto'

/* --------------------------------------------- */
/*      PLANNING YEARS (SIB-928)                 */
/* --------------------------------------------- */

/**
 * The years SIBs may plan into and which of them are open today. Not cached: a year opens on a
 * date, and an administrator may just have moved that date.
 */
export function getPlanningYears() {
  return API<PlanningYearsResponse>(
    `/planning-years`,
    { headers: { 'x-disable-cache': '1' } },
    'Fehler beim Laden der Planungsjahre',
    'PLANNING_YEARS_FETCH_ERROR'
  )
}
